import type {PropsWithChildren} from 'react'

import {SidebarPageLayout, type SidebarPageLayoutProps} from '../SidebarPageLayout/SidebarPageLayout'
import {FilteredListPageLayout as CoreLayout} from '@github-ui/layout-primitives-core'

export {
  FilteredListPageLayoutHeader,
  FilteredListPageLayoutSidebar,
  FilteredListPageLayoutContent,
  FilteredListPageLayoutFooter,
  FilteredListPageLayoutSidebarTrigger,
  FilteredListPageLayoutFilterBar,
  FilteredListPageLayoutResults,
  FilteredListPageLayoutHeaderActions,
  type FilteredListPageLayoutFilterBarProps,
  type FilteredListPageLayoutResultsProps,
  type FilteredListPageLayoutHeaderActionsProps,
  type FilteredListPageLayoutHeaderProps,
  type FilteredListPageLayoutSidebarProps,
  type FilteredListPageLayoutContentProps,
  type FilteredListPageLayoutFooterProps,
  type FilteredListPageLayoutSidebarTriggerProps,
} from '@github-ui/layout-primitives-core'

export type FilteredListPageLayoutProps = SidebarPageLayoutProps

function Root(props: PropsWithChildren<FilteredListPageLayoutProps>) {
  return <SidebarPageLayout {...props} />
}

Root.displayName = 'FilteredListPageLayout'
export const FilteredListPageLayout = Object.assign(Root, {
  Header: CoreLayout.Header,
  PageHeader: SidebarPageLayout.PageHeader,
  Sidebar: CoreLayout.Sidebar,
  SidebarTrigger: CoreLayout.SidebarTrigger,
  Content: CoreLayout.Content,
  FilterBar: CoreLayout.FilterBar,
  Results: CoreLayout.Results,
  HeaderActions: CoreLayout.HeaderActions,
  Footer: CoreLayout.Footer,
})
export const FilteredListPageLayoutPageHeader = SidebarPageLayout.PageHeader
export {Root as FilteredListPageLayoutRoot}
